import { Tag as TagBase } from 'antd';
import React, { forwardRef } from 'react';
import { StyledTag } from './Tag.style';
import { ITagProps } from './Tag.type';

const Tag = forwardRef<HTMLDivElement, ITagProps>(function Tag(
  { color = 'white', clickAble = false, ...props },
  ref,
) {
  return (
    <StyledTag color={color} ref={ref} {...props}>
      <TagBase
        className={`${color ? color : 'white'} base-tag ${
          clickAble && 'click-able'
        }`}
      >
        {props.children}
      </TagBase>
    </StyledTag>
  );
});

export default Tag;
